export { default } from './PopupContent';
//# sourceMappingURL=index.js.map